import type { PropType } from 'vue';
import type { TSelectDropdownItemprops } from './TSelectDropdownItem.types';
import { merge } from 'es-toolkit/compat';
import { computed, defineComponent } from 'vue';
import { useStyles } from './TSelectDropdownItem.styles';

export const TSelectDropdownItem = defineComponent({
  name: 'TSelectDropdownItem',
  emits: ['click'],
  props: {
    label: String as PropType<TSelectDropdownItemprops['label']>,
  },
  setup(_props, { slots, emit, attrs }) {
    const props = computed(() => merge({}, _props, attrs));

    const baseClass = useStyles();

    const handleClick = () => {
      emit('click');
    };

    const handleKeydown = (event: KeyboardEvent) => {
      if (event.key === 'Enter' && !props.value.disabled) {
        emit('click');
        event.preventDefault();
      }
    };

    return () => (
      <div
        class={baseClass.value}
        onClick={handleClick}
        role="menuitem"
        onKeydown={handleKeydown}
        tabindex={0}
      >
        {slots.default?.()}
        {slots.label?.()
        || (props.value.label && (
          <label class={`${baseClass.value}__label`}>
            {props.value.label}
          </label>
        ))}
      </div>
    );
  },
});
